<script type="text/babel">
import ManagesModalState from "dashboard-js/mixins/ManagesModalState";
import RestoreScrollOnPageBack from "dashboard-js/mixins/RestoreScrollOnPageBack";

export default {
	mixins: [ManagesModalState, RestoreScrollOnPageBack],

	props: ["course", "user"],

	data() {
		return {};
	},

	computed: {
		buttonText() {
			return this.course.course_user_entry ? 'Start igen' : 'Start';
		},
		courseStatus() {
			const entry = this.course.course_user_entry;

			if (!entry) {
				return "Ikke startet";
			} else if (entry.passed && entry.finished_at) {
				return "Bestået";
			} else if (!entry.passed && !entry.finished_at) {
				return "I gang";
			} else if (entry.finished_at) {
				return "Fejlet, prøv igen";
			}
		},
		isCourseAvailable() {
			const entry = this.course.course_user_entry;
			return !entry || (!entry.passed && !entry.finished_at);
		},
		isCourseFinished() {
			return this.course.course_user_entry ? this.course.course_user_entry.passed : 0;
		},
		isRetryAvailable() {
			if (!this.course.course_user_entry || !this.course.course_user_entry.finished_at) {
				return false;
			}

			const currentDate = new Date();
			currentDate.setHours(currentDate.getHours() - 1);

			const retryWaitingPeriodInSeconds = this.course.retry_waiting_period;
			const finishedAt = new Date(this.course.course_user_entry.finished_at);

			const retryAvailableTime =
				finishedAt.getTime() + retryWaitingPeriodInSeconds * 1000;

			return currentDate.getTime() > retryAvailableTime;
		},
		remainingSecondsUntilRetry() {
			if (!this.course.course_user_entry || !this.course.course_user_entry.finished_at) {
				return false;
			}

			const currentDate = new Date();
			currentDate.setHours(currentDate.getHours() - 1);

			const retryWaitingPeriodInSeconds = this.course.retry_waiting_period;
			const finishedAt = new Date(this.course.course_user_entry.finished_at);

			const retryAvailableTime =
				finishedAt.getTime() + retryWaitingPeriodInSeconds * 1000;

			// Calculate remaining seconds until retry is available
			const remainingSeconds = Math.max(
				0,
				(retryAvailableTime - currentDate.getTime()) / 1000
			);

			return Math.round(remainingSeconds);
		},
	},

	created() { },

	methods: {
		async handleButtonClick() {
			if (!this.course.course_user_entry) {
				await this.createCourseUserEntry();
			}
			this.navigateTo();
		},
		async createCourseUserEntry() {
			try {
				const response = await axios.post(route('influencer.school.entry.create'), {
					course_id: this.course.id,
				});
				this.course.course_user_entry = response.data;
			} catch (error) {
				console.error('Error creating course user entry:', error);
			}
		},

		getDate(timestamp) {
			return moment(timestamp).format("D. MMM. YYYY");
		},

		navigateTo() {
			const coursePath = `/school/course/${this.course.id}`;

			window.location.href = `${coursePath}/video`;
		}
	},
};
</script>
